<template>
  <el-container>
    <el-main>
      <el-row :gutter="24" :style="getRowheight()">
        <el-col :span="18">
          <el-table
            :data="tableData"
            size="mini"
            stripe
            border
            :row-class-name="rowClassName"
            style="width: 96%;margin: 0 auto">
            <el-table-column
              type="index"
              align="center"
              label="序号"
              :index="indexMethod"
              width="50">
            </el-table-column>
            <el-table-column
              prop="seedcode"
              label="商品编码"
              align="left" :show-overflow-tooltip="true"
              width="120"
              header-align="center">
            </el-table-column>
            <el-table-column
              prop="seedname" :show-overflow-tooltip="true"
              label="名称"
              align="left"
              header-align="center">
            </el-table-column>
            <el-table-column
              prop="opccode"
              label="条码"
              align="left"
              width="200"
              header-align="center">
            </el-table-column>
            <el-table-column
              prop="type"
              label="R/L"
              align="right"
              width="60"
              header-align="center">
            </el-table-column>
            <el-table-column
              prop="Y"
              label="球镜"
              align="right"
              width="80"
              header-align="center">
            </el-table-column>
            <el-table-column
              prop="X"
              label="柱镜"
              width="80"
              align="right"
              header-align="center">
            </el-table-column>
            <el-table-column
              prop="totalnumber"
              label="数量"
              align="center"
              width="90"
              header-align="center">
              <template slot-scope="scope">
                <el-input-number :controls="false" style="width: 100%" size="small"
                  v-model="scope.row.totalnumber" :min="0" :precision="0"
                  :ref="'qty_' + scope.$index"
                  onfocus="this.select()"
                  @change="totalNumber"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="70">
              <template slot-scope="scope">
                <el-button size="mini" type="danger"
                  @click="handleDelete(scope.$index, scope.row)">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="6">
          <p style="text-align: left;font-size: 15px">
            <el-input ref="scanleninput" style="width: 200px" size="small"
              v-model="onlycode"
              onfocus="this.select()"
              placeholder="扫光度码"
              @change="scanBarcode()"></el-input>
          </p>
          <p style="text-align: left;font-size: 15px;line-height: 44px">
            总数：<b>{{totalnumber}}</b>
          </p>
          <p style="text-align: left;font-size: 15px">备注：</p>
          <el-input
            type="textarea"
            :rows="6"
            placeholder="请输入备注内容"
            v-model="remark">
          </el-input>
          <p style="margin-top: 30px">
            <el-button type="danger" @click="clearAll" :disabled="tableData.length==0" size="small">清空</el-button>
            <el-button type="primary" @click="submitReturn"
              :loading="btnupdatevisible"
              v-if="tableData.length>0">生成退货单</el-button>
          </p>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
  import {bardetail} from '@/api/set/jxcgoodsbarcode';
  import {cangKuGoodsUpdate} from '@/api/set/csagreement';

  export default {
    name: "HsScanlensReturn",
    data() {
      return {
        onlycode: '',
        tableData: [],
        btnupdatevisible: false,
        totalnumber: 0,
        remark: '',
        cangkucode: '',
        cangkuname: '',
        customerserial: '',
        customername: '',
        highlightRowIndex: -1,
        highlightTimer: null,
      }
    },
    methods: {
      //扫码输入回车触发
      scanBarcode() {
        if (!this.onlycode) return;
        //检查是否已扫过同一条码，有则数量+1
        for (let i in this.tableData) {
          if (this.tableData[i].opccode == this.onlycode) {
            this.onlycode = '';
            if (this.tableData[i].totalnumber == null) this.tableData[i].totalnumber = 0;
            this.tableData[i].totalnumber += 1;
            this.totalNumber();
            this.highlightNewRow(parseInt(i));
            return;
          }
        }
        //新条码，调用 bardetail 查询商品信息
        bardetail({barcode: this.onlycode}).then(response => {
          this.onlycode = '';
          if (!response.data.obj || response.data.code != 0 || !response.data.obj.seedcode) {
            this.$message({message: '光度码无效！', type: 'error'});
            return;
          }
          this.add2Table(response.data.obj);
        });
      },
      //将扫到的商品加入表格
      add2Table(goodsbar) {
        var p = JSON.parse(goodsbar.packagesize);
        this.tableData.unshift({
          seedcode: goodsbar.seedcode,
          seedname: goodsbar.seedname,
          totalnumber: 1,
          Y: p.Y,
          X: p.X,
          A: p.A || '',
          type: p.type || '',
          opccode: goodsbar.barcode,
        });
        this.totalNumber();
        this.highlightNewRow(0);
      },
      //计算总数
      totalNumber() {
        this.totalnumber = 0;
        for (let i in this.tableData) {
          if (this.tableData[i].totalnumber == null || isNaN(this.tableData[i].totalnumber)) {
            this.tableData[i].totalnumber = 0;
          }
          this.totalnumber += parseInt(this.tableData[i].totalnumber);
        }
      },
      //删除一行
      handleDelete(index, row) {
        this.tableData.splice(index, 1);
        this.totalNumber();
      },
      //清空全部
      clearAll() {
        this.tableData = [];
        this.totalnumber = 0;
        this.remark = '';
        this.$refs.scanleninput.focus();
      },
      //生成退货单
      submitReturn() {
        //校验数量
        for (let i in this.tableData) {
          if (!this.tableData[i].totalnumber || this.tableData[i].totalnumber <= 0) {
            this.$message({type: 'error', message: '数量必须大于0！'});
            return;
          }
        }
        if (!this.cangkucode) {
          this.$message({type: 'error', message: '请先选择仓库！'});
          return;
        }
        if (!this.customerserial) {
          this.$message({type: 'error', message: '客户信息缺失，请关闭后重新选择！'});
          return;
        }

        this.btnupdatevisible = true;

        //按 seedcode 分组，每组调用一次 cangKuGoodsUpdate
        var groups = {};
        for (let i in this.tableData) {
          var item = this.tableData[i];
          if (!groups[item.seedcode]) {
            groups[item.seedcode] = {seedname: item.seedname, arr: []};
          }
          groups[item.seedcode].arr.push({
            Number: item.totalnumber,
            seedcode: item.seedcode,
            X: parseFloat(item.X || 0).toFixed(2),
            Y: parseFloat(item.Y || 0).toFixed(2),
            A: item.A || '',
            type: item.type || '',
            filltemplate: '10'
          });
        }

        var groupKeys = Object.keys(groups);
        var completed = 0;
        var hasError = false;
        var self = this;

        groupKeys.forEach(function(seedcode) {
          if (hasError) return;
          cangKuGoodsUpdate({
            cangkucode: self.cangkucode,
            cangkuname: self.cangkuname || window.localStorage.getItem('cangkuname') || '',
            arr: JSON.stringify(groups[seedcode].arr),
            seedcode: seedcode,
            seedname: groups[seedcode].seedname || '',
            deliveryaddress: window.localStorage.getItem('deliveryaddress') || '',
            elinkman: window.localStorage.getItem('elinkman') || '',
            elinkmantel: window.localStorage.getItem('elinkmantel') || '',
            customerserial: self.customerserial,
            customername: self.customername,
            remark: self.remark,
            tracknum: window.localStorage.getItem('tracknum') || '',
            logisticstracknum: window.localStorage.getItem('logisticstracknum') || '',
            settingmenthod: window.localStorage.getItem('settingmenthod') || '',
            roletype: window.localStorage.getItem('roletype') || '',
            filltemplate: '10',
          }, {ssotoken: window.localStorage.getItem('keFTtoken') || window.localStorage.getItem('hpweb_token') || ''}).then(function(request) {
            if (request.data.code == 0) {
              completed++;
              if (completed == groupKeys.length) {
                //全部成功
                self.$message({type: 'success', message: '退货单生成成功！'});
                var erpserial = request.data.erpserial || '';
                localStorage.setItem('THcloseIframe', erpserial);
                //通知父组件（WriteReturnOrder）退货完成
                self.onReturnSuccess(erpserial);
              }
            } else {
              hasError = true;
              self.$message({type: 'error', message: request.data.msg || '退货单生成失败！'});
              self.btnupdatevisible = false;
            }
          }).catch(function() {
            hasError = true;
            self.$message({type: 'error', message: '请求失败，请重试！'});
            self.btnupdatevisible = false;
          });
        });
      },
      //退货成功后通知父组件
      onReturnSuccess(erpserial) {
        this.btnupdatevisible = false;
        //优先通过 $parent 调用 WriteReturnOrder 的方法（v-if 内嵌场景）
        if (this.$parent && typeof this.$parent.handleScanReturnSuccess === 'function') {
          this.$parent.handleScanReturnSuccess(erpserial);
          return;
        }
        //兜底：通过 window.parent 调用（iframe 场景）
        try {
          if (window.parent && typeof window.parent.handleScanReturnSuccess === 'function') {
            window.parent.handleScanReturnSuccess(erpserial);
            return;
          }
        } catch(e) {}
        //最终兜底：清空并关闭当前窗口
        this.tableData = [];
        this.remark = '';
        this.totalNumber();
        try { window.close(); } catch(e) {}
      },
      //高亮提示
      highlightNewRow(index) {
        if (index < 0) return;
        if (this.highlightTimer) clearTimeout(this.highlightTimer);
        this.highlightRowIndex = -1;
        this.$nextTick(() => {
          this.highlightRowIndex = index;
          this.highlightTimer = setTimeout(() => {
            this.highlightRowIndex = -1;
          }, 1800);
        });
      },
      rowClassName({rowIndex}) {
        return rowIndex === this.highlightRowIndex ? 'row-new-highlight' : '';
      },
      getRowheight() {
        return "max-height: " + this.tableHeight(10) + "px;overflow: auto";
      },
      indexMethod(index) {
        return index + 1;
      },
    },
    mounted() {
      //从 localStorage 读取由 WriteReturnOrder 写入的客户/仓库信息
      this.cangkucode = window.localStorage.getItem('cangkucode') || '';
      this.cangkuname = window.localStorage.getItem('cangkuname') || '';
      var keFuInfoModel = window.localStorage.getItem('keFuInfoModel');
      if (keFuInfoModel) {
        try {
          var info = JSON.parse(keFuInfoModel);
          this.customerserial = info.memberDO ? info.memberDO.customerserial : '';
          this.customername = info.memberDO ? info.memberDO.deptname : '';
        } catch(e) {
          this.customerserial = '';
          this.customername = '';
        }
      }
      document.title = '扫光度码退货';
      this.$nextTick(() => {
        if (this.$refs.scanleninput) this.$refs.scanleninput.focus();
      });
    },
  }
</script>
<style scoped>
  /* 扫码新增/数量变化行的高亮闪烁提示 */
  .el-table >>> tr.row-new-highlight > td {
    animation: hsRowFlash 1.6s ease-out;
  }
  @keyframes hsRowFlash {
    0% { background-color: #b8e6b8; }
    55% { background-color: #dcf2dc; }
    100% { background-color: transparent; }
  }
</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/HsScanlensReturn.vue